export default __webpack_public_path__ + "static/media/Book1.45c18d93.webp";